/** Composer anchor for the readiness-rail "Request approval" terminal action. */
export const CARE_PLAN_SUBMIT_FOR_REVIEW_ANCHOR =
  'care-plan-readiness-request-approval-cta' as const;

export type AcknowledgementBlockerResolution = {
  label: string;
  actionLabel: string;
  hash: typeof CARE_PLAN_SUBMIT_FOR_REVIEW_ANCHOR | 'composer-agree';
};

/**
 * Status-aware acknowledgement blocker destination.
 * DRAFT is writable for in-visit capture (paired with content-hash currency at
 * activation) — route to Agreement and plan review, same as other writable statuses.
 * `planStatus` is retained for call-site compatibility / future status routing.
 */
export function resolveAcknowledgementBlockerForStatus(
  _planStatus?: string | null,
): AcknowledgementBlockerResolution {
  return {
    label:
      "Record the plan-review evidence required by this plan's provider template for the current version.",
    actionLabel: 'Record plan review',
    hash: 'composer-agree',
  };
}
